module.exports = ".card {\n  margin-bottom: 40px; }\n  .card .card-body {\n    padding-top: 0; }\n  .card h5 {\n    margin-bottom: 0; }\n"